var _defs, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoAlly = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133.99,
    height: 98.51,
    viewBox: "0 0 133.99 98.51",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:square;}.b{fill:#1ed6bb;}.c,.d{stroke:none;}.d{fill:#4D4DFF;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-943.202 -1645.449)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1010.2,1645.449l66.994,67-31.515,31.514-35.48-35.479-35.479,35.479L943.2,1712.445Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 1010.197875976562 1648.160522460938 L 945.913330078125 1712.445068359375 L 974.7183837890625 1741.248046875 L 1008.842224121094 1707.124267578125 L 1010.197875976562 1705.768676757812 L 1011.553527832031 1707.124267578125 L 1045.677490234375 1741.248046875 L 1074.480712890625 1712.445068359375 L 1010.197875976562 1648.160522460938 M 1010.197875976562 1645.44921875 L 1077.192016601562 1712.445068359375 L 1045.677490234375 1743.959350585938 L 1010.197875976562 1708.47998046875 L 974.7183837890625 1743.959350585938 L 943.201904296875 1712.445068359375 L 1010.197875976562 1645.44921875 Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 21,
    height: 21,
    transform: "translate(31.724 50.241) rotate(45)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoAlly);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logoAlly.085990922cf2efd066f08fa070f3a3f4.svg";